export default __webpack_public_path__ + "static/media/Casa Bianca Prosecco - proportioned_170.9862b678.jpg";